function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Send");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Chat-Widget",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ChatWidget",
  transform: "translate(-353.000000, -553.000000)",
  fill: "#FFFFFF",
  stroke: "#FFFFFF",
  "data-svg-class": "Stroke"
}, React.createElement("g", {
  id: "Buttons/Circle/Send",
  transform: "translate(344.000000, 539.000000)"
}, React.createElement("g", {
  id: "Icons/Send",
  transform: "translate(8.800000, 14.666667)"
}, React.createElement("g", {
  id: "send"
}, React.createElement("path", {
  d: "M21.2666667,0.357694399 C21.2610855,0.336958492 21.2610855,0.316222585 21.2555044,0.295486678 C21.2499233,0.269566794 21.238761,0.248830886 21.2275988,0.228094979 C21.2220177,0.217727026 21.2164365,0.202175095 21.2108554,0.191807142 C21.2052743,0.186623165 21.1996932,0.181439188 21.194112,0.171071234 C21.1773686,0.150335327 21.1606253,0.134783397 21.1438819,0.119231466 C21.1271385,0.103679536 21.104814,0.0881276056 21.0880706,0.0725756752 C21.0824895,0.0673916984 21.0769084,0.0622077216 21.0657461,0.0570237448 C21.0545839,0.051839768 21.0378405,0.0466557912 21.0266782,0.0414718144 C21.0043537,0.0311038608 20.9764481,0.0207359072 20.9541236,0.0155519304 C20.9317991,0.0103679536 20.9094746,0.0051839768 20.8871501,0.0051839768 C20.8536633,0 20.8257577,0 20.7978521,0 C20.7755275,0 20.7476219,0.0051839768 20.7252974,0.0103679536 C20.708554,0.0155519304 20.6918107,0.0103679536 20.6806484,0.0155519304 L1.03508367,6.23632409 C0.856487627,6.29334783 0.733511788,6.44368316 0.733511788,6.61993837 C0.728121721,6.79619358 0.845325374,6.95171289 1.01834029,7.01392061 L10.1992931,10.2901939 L14.167474,18.8178358 C14.2400286,18.9681711 14.4018813,19.0666667 14.5748962,19.0666667 C14.5804773,19.0666667 14.5916396,19.0666667 14.5972207,19.0666667 C14.7813979,19.0562987 14.9432505,18.9422512 14.9990618,18.776364 L21.2499233,0.528765633 C21.2555044,0.51839768 21.2555044,0.50284575 21.2555044,0.487293819 C21.2610855,0.466557912 21.2666667,0.440638028 21.2666667,0.419902121 C21.2666667,0.40435019 21.2666667,0.383614283 21.2666667,0.357694399 Z M2.49175765,6.65622621 L19.1514198,1.37893783 L10.4225382,9.48667754 L2.49175765,6.65622621 Z M14.5135038,17.4751858 L11.0643677,10.062099 L19.8434794,1.90770346 L14.5135038,17.4751858 Z",
  id: "Shape",
  strokeWidth: 0.5,
  fillRule: "nonzero"
}))))));

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Send.a487c06b.svg";
export { ForwardRef as ReactComponent };